<template>
    <div class="row">
        <div class="col">
            <roles-crud></roles-crud>
        </div>
    </div>
</template>

<script>
    import RolesCrud from './roles/RolesCrud';

    export default {
        components: {
            RolesCrud
        }
    }
</script>
